import React, { useState } from 'react';
import '../assets/public/PopupModal.css';

const PopupModal = ({ show, onClose, onSubmit, defaultValue }) => {
    // useState must be called unconditionally
    const [inputValue, setInputValue] = useState(defaultValue || "");

    if (!show) {
        return null; // Don't render the modal if 'show' is false
    }

    return (
        <div className="modal-overlay">
            <div className="modal-content">
                <h2>{defaultValue ? "Edit Publication" : "Add New Publication"}</h2>
                <input
                    type="text"
                    value={inputValue}
                    onChange={(e) => setInputValue(e.target.value)}
                    placeholder="Enter text"
                />
                <div className="modal-actions">
                    <button onClick={() => onSubmit(inputValue)}>Submit</button>
                    <button onClick={onClose}>Cancel</button>
                </div>
            </div>
        </div>
    );
};

export default PopupModal;